import React from 'react';
import { CUIText, Dropdown, SelectTypes } from '@dotcom/crown-ui';
import { SummaryRowProps } from '../summary-drawer-types';
import styles from '../summary-drawer.module.scss';

export const SummaryRow = ({
  data,
  options,
  selectedOption,
  onSelect,
  register,
  isSelectDisabled,
}: SummaryRowProps): React.ReactElement => {
  return (
    <div className={styles['summary-row']} data-testid="summary-grid-row">
      <div className={styles.concept}>
        <div className={styles['title-container']}>
          <CUIText as="span" color="textPrimary">
            {data.title}
          </CUIText>
        </div>
        {data.subtitle && (
          <div className={styles['subtitle-container']}>
            <CUIText as="span" color="textPrimary" weight="bold">
              {data.subtitle}
            </CUIText>
          </div>
        )}
      </div>
      {onSelect && options && options.length > 0 && (
        <div className={styles['options-container']}>
          <form>
            <Dropdown
              testId="summary-grid-dropdown"
              hideLabel={true}
              label="Select an option"
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onSelect(e.target.value)}
              options={options}
              variant={SelectTypes.Default}
              value={selectedOption || ''}
              isDisabled={isSelectDisabled}
              register={register('quantity')}
            />
          </form>
        </div>
      )}
      <div className={styles.detail}>
        <CUIText as="span" color="textPrimary">
          {data.detail}
        </CUIText>
      </div>
    </div>
  );
};
